import { useMutation } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { authAtom } from '../../state';
import { AuthTransfersAPI } from '../../modules/Auth/api/AuthTransfersAPI';
import { AuthResponse } from '../../modules/Auth/types';
import { useCustomToast } from '../../components';
import { useQueryClient } from '@tanstack/react-query';

export const useLogin = () => {
  const setAuth = useSetAtom(authAtom);
  const { showToast } = useCustomToast();

  return useMutation({
    mutationKey: ['login'],
    mutationFn: (credentials: { email: string; password: string }) =>
      AuthTransfersAPI.login(credentials),
    onSuccess: (req: AuthResponse) => {
      setAuth(req);
    },
    onError: (e: any) => {
      const message = e?.response?.data?.message;
      showToast('error', message || 'Usuario o contraseña no válidos. Por favor, inténtelo de nuevo.');
    },
    throwOnError: false
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();

  const setAuth = useSetAtom(authAtom);
  return useMutation({
    mutationKey: ['logout'],
    mutationFn: () => AuthTransfersAPI.logout(),
    onSuccess: () => {
      setAuth(null);
      queryClient.clear();
    },
  });
};
